import { ApiBase } from './ApiBase';
class HarmonisedSystemCodeApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getHSCodes = (params) => {
            return this.get('/hs-codes', params);
        };
    }
}
export const HarmonisedSystemCodeApiClient = new HarmonisedSystemCodeApiClientModel();
